import { MinzeElement } from "minze";

export interface TjSearchIcon {}

export class TjSearchIcon extends MinzeElement {
  html = () => `
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.8577 22.0001C17.9072 22.0001 22.0006 17.9067 22.0006 12.8572C22.0006 7.80775 17.9072 3.71436 12.8577 3.71436C7.80824 3.71436 3.71484 7.80775 3.71484 12.8572C3.71484 17.9067 7.80824 22.0001 12.8577 22.0001Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M24.2859 24.2858L19.3145 19.3143" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  css = () => `
    
  `;
}
